<form [formGroup]="form" class="eidos-change-password-dialog">
  <h1 class="eidos-change-password-dialog-title">Change password</h1>

  <div class="eidos-change-password-dialog-content">

    <div class="password-requirements">
      <label *ngIf="requirements.mustChangePassword">Password change is required on user first access or after credentials reset
      </label>

      <div *ngIf="requirements.minPasswordLength > 0">
        <i class="fa fa-circle-exclamation password-requirements-error-icon" aria-hidden="true"
          *ngIf="form.controls.newPassword.value.length < requirements.minPasswordLength || form.controls.newPassword.errors && form.controls.newPassword.errors.minlength"></i>
        <i class="fa fa-check password-requirements-ok-icon" aria-hidden="true"
          *ngIf="form.controls.newPassword.value.length >= requirements.minPasswordLength && !(form.controls.newPassword.errors && form.controls.newPassword.errors.minlength)"></i>
        <label>New password must be at least {{ requirements.minPasswordLength }} characters long
        </label>
        <br />
      </div>

      <div *ngIf="requirements.minPasswordLowerCaseChars > 0">
        <i class="fa fa-circle-exclamation password-requirements-error-icon" aria-hidden="true"
          *ngIf="form.controls.newPassword.errors && form.controls.newPassword.errors.minPasswordLowerCaseChars"></i>
        <i class="fa fa-check password-requirements-ok-icon" aria-hidden="true"
          *ngIf="!(form.controls.newPassword.errors && form.controls.newPassword.errors.minPasswordLowerCaseChars)"></i>
        <label>New password must contain at least {{ requirements.minPasswordLowerCaseChars }} lower case characters</label>
        <br />
      </div>

      <div *ngIf="requirements.minPasswordUpperCaseChars > 0">
        <i class="fa fa-circle-exclamation password-requirements-error-icon" aria-hidden="true"
          *ngIf="form.controls.newPassword.errors && form.controls.newPassword.errors.minPasswordUpperCaseChars"></i>
        <i class="fa fa-check password-requirements-ok-icon" aria-hidden="true"
          *ngIf="!(form.controls.newPassword.errors && form.controls.newPassword.errors.minPasswordUpperCaseChars)"></i>
        <label>New password must contain at least {{ requirements.minPasswordUpperCaseChars }} upper case characters</label>
        <br />
      </div>

      <div *ngIf="requirements.minPasswordNumericalChars > 0">
        <i class="fa fa-circle-exclamation password-requirements-error-icon" aria-hidden="true"
          *ngIf="form.controls.newPassword.errors && form.controls.newPassword.errors.minPasswordNumericalChars"></i>
        <i class="fa fa-check password-requirements-ok-icon" aria-hidden="true"
          *ngIf="!(form.controls.newPassword.errors && form.controls.newPassword.errors.minPasswordNumericalChars)"></i>
        <label>New password must contain at least {{ requirements.minPasswordNumericalChars }} numerical characters</label>
        <br />
      </div>

      <div *ngIf="requirements.minPasswordSpecialChars > 0">
        <i class="fa fa-circle-exclamation password-requirements-error-icon" aria-hidden="true"
          *ngIf="form.controls.newPassword.errors && form.controls.newPassword.errors.minPasswordSpecialChars"></i>
        <i class="fa fa-check password-requirements-ok-icon" aria-hidden="true"
          *ngIf="!(form.controls.newPassword.errors && form.controls.newPassword.errors.minPasswordSpecialChars)"></i>
        <label>New password must contain at least {{ requirements.minPasswordSpecialChars }} special characters</label>
        <br />
      </div>
    </div>

    <div class="field">
      <label>Current password</label>
      <input type="password" formControlName="oldPassword" required>
      <span class="field-error" *ngIf="form.controls.oldPassword.invalid && form.controls.oldPassword.touched && form.controls.oldPassword.errors?.required">
        Field must be filled
      </span>
    </div>

    <div class="field">
      <label>New password</label>
      <input type="password" formControlName="newPassword" required>
      <span class="field-error" *ngIf="form.controls.newPassword.invalid && form.controls.newPassword.touched && form.controls.newPassword.errors?.required">
        Field must be filled
      </span>
    </div>

    <div class="field">
      <label>Retype new password</label>
      <input type="password" formControlName="retypedNewPassword" required>
      <span class="field-error" *ngIf="form.controls.retypedNewPassword.invalid && form.controls.retypedNewPassword.touched && form.controls.retypedNewPassword.errors?.required">
        Field must be filled
      </span>
    </div>

    <span class="field-error"
      *ngIf="form.invalid && form.errors && form.errors['notSame'] && form.controls.newPassword.dirty && form.controls.retypedNewPassword.dirty">
      New Password fields must match
    </span>


    <span class="field-error" *ngIf="responseError">{{ responseError }}</span>
  </div>

  <div class="eidos-change-password-dialog-actions">

    <button class="eidos-button eidos-button-normal eidos-button-cancel" type="button" [disabled]="requirements.mustChangePassword" (click)="onCancelClick()">Cancel</button>
    <button class="eidos-button eidos-button-normal eidos-button-success" type="submit" (click)="onSetPasswordClick()" [disabled]="form.invalid || loading">
      {{ loading ? "" : "Submit" }}
    </button>
    <eidos-progress-spinner *ngIf="loading" class="change-password-request-spinner" style="margin:0 auto;" [diameter]="20"></eidos-progress-spinner>
  </div>
</form>
